import apiClient from '@u/apiClient'
import DeleteContactController from '@/wayfinder/actions/App/Http/Controllers/Contact/DeleteContactController'
import GetContactListController from '@/wayfinder/actions/App/Http/Controllers/Contact/GetContactListController'
import GetContactByIdController from '@/wayfinder/actions/App/Http/Controllers/Contact/GetContactByIdController'
import GetContactWithRelationsController from '@/wayfinder/actions/App/Http/Controllers/Contact/GetContactWithRelationsController'
import CreateContactController from '@/wayfinder/actions/App/Http/Controllers/Contact/CreateContactController'
import UpdateContactController from '@/wayfinder/actions/App/Http/Controllers/Contact/UpdateContactController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  deleteContact({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteContactController.delete.delete({ contact: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  undoDeleteContact: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteContactController.undo.get({ contact: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region fetch
  fetchContactList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetContactListController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchRoleContactList({ commit }, payload) {
    await apiClient
      .route(GetContactListController.get({ query: { role: payload.id } }))
      .then(async (response) => {
        commit('setRoleContactList', response.data.contacts)
        commit('setContactMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchContactList', reason)
      })
  },

  fetchContactById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetContactByIdController.get({ mergeableContact: payload.contact_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchContactWithRelations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetContactWithRelationsController.get({
            mergeableContact: payload.contact_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewContact({ commit }, predefinedRole) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'contact' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  storeNewContact({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateContactController.post(), payload.contact)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateContact({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateContactController.put({ contact: payload.id }),
          payload.contact
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
